import React from 'react';

import { HashRouter } from 'react-router-dom';

import ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux';
import store from './store/store';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </HashRouter>
  </React.StrictMode>
);

